import { ButtonLink, PlusIcon, Stack } from '@fukuri-admins/ui/common';
import emptyTopBannersImage from '~/assets/images/empty_top_banners.svg';
import styles from './styles.module.scss';

type Props = {
  createLink: string;
};

/**
 * トップバナー一覧が空の場合のプレゼンテーションコンポーネント
 */
export const TopBannerListEmptyPresentation: React.FC<Props> = ({ createLink }) => (
  <div className={styles.content}>
    <div className={styles.header}>
      <span className={styles.title}>バナー</span>
    </div>
    <div className={styles.emptyContent}>
      <div className={styles.emptyContent__image}>
        <img src={emptyTopBannersImage} alt='バナーがありません' />
      </div>
      <Stack direction='column' gap={16} alignItems='center' justifyContent='center'>
        <span className={styles.emptyContentDescription}>作成済みのバナーはまだありません</span>
        <div>
          <ButtonLink
            variant='primary'
            size='md'
            icon={<PlusIcon size='xs' />}
            iconPosition='left'
            to={createLink}
          >
            新規作成
          </ButtonLink>
        </div>
      </Stack>
    </div>
  </div>
);
